import {
  adaptDatabaseFieldFunction,
  isFormDataValidFunction,
  parseFormDataFunction,
} from '@/modules/corporate/modules/database/fields/types';
import { DatabaseNumberFormatEnum } from '@/types/schema';

export const isFormDataValid: isFormDataValidFunction = (data) => !!String(data);

export const parseFormData: parseFormDataFunction = (data: number | string) => ({
  value: data.toString(),
});

export const adaptNumberField: adaptDatabaseFieldFunction = ({ metadataField, viewField }) => ({
  metadataField: {
    ...metadataField,
    numberFormat: metadataField.numberFormat || DatabaseNumberFormatEnum.Number,
  },
  viewField,
});
